import SettingPercentage from './SettingPercentage'

export default SettingPercentage